import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DISHES_PROGRESS_COUNTS_QUERY } from '../graphql/queries'
import { FETCH_DISHES_PROGRESS_COUNTS } from '../redux/action-types'

const useDishesProgressCountsLazyQuery = () => {
  const dispatch = useDispatch()

  const {
    progressCounts: data,
    isProgressCountsLoading: isLoading,
    progressCountsError: error,
  } = useSelector(store => store.dishes.dishes)

  const fetch = useCallback(
    menuId =>
      apolloService.query({
        query: DISHES_PROGRESS_COUNTS_QUERY,
        variables: {
          menuId,
        },
        dispatch,
        action: FETCH_DISHES_PROGRESS_COUNTS,
      }),
    [dispatch],
  )

  return [fetch, { isLoading, error, data }]
}

export default useDishesProgressCountsLazyQuery
